import { useDispatch, useSelector } from 'react-redux';

import { RootState } from '../../store/store';

import {
    setChannels,
    setSelectedChannel,
    setChannelModalOpen,
    clearSelectedChannel,
} from '../../store/slices/realtime/realtimeSlice';

import RealtimeService
    from '../../services/realtime/realtimeService';

import useLoading
    from '../useLoading';

import useApiErrorHandler
    from '../useApiErrorHandler';

import {
    RealtimeChannelCreateDTO,
    RealtimeChannelDTO,
    RealtimeChannelUpdateDTO,
} from '../../types/realtime';

export const useRealtimeChannels = () => {

    const dispatch =
        useDispatch();

    const { handle } =
        useApiErrorHandler();

    const {
        showLoadingIndicator,
        hideLoadingIndicator,
    } = useLoading();

    const realtime =
        useSelector(
            (state: RootState) =>
                state.realtime
        );

    const handlerGetChannels =
        async () => {

            try {

                showLoadingIndicator();

                const response =
                    await RealtimeService
                        .getChannels();

                dispatch(
                    setChannels(response)
                );

            } catch (error) {

                handle(error);

            } finally {

                hideLoadingIndicator();
            }
        };

    const handlerCreateChannel =
        async (
            dto: RealtimeChannelCreateDTO
        ) => {

            try {

                showLoadingIndicator();

                await RealtimeService
                    .createChannel(dto);

                await handlerGetChannels();

                closeModal();

            } catch (error) {

                handle(error);

            } finally {

                hideLoadingIndicator();
            }
        };

    const handlerUpdateChannel =
        async (
            channelId: number,
            dto: RealtimeChannelUpdateDTO
        ) => {

            try {

                showLoadingIndicator();

                await RealtimeService
                    .updateChannel(
                        channelId,
                        dto
                    );

                await handlerGetChannels();

                closeModal();

            } catch (error) {

                handle(error);

            } finally {

                hideLoadingIndicator();
            }
        };

    const handlerDeleteChannel =
        async (
            channelId: number
        ) => {

            try {

                showLoadingIndicator();

                await RealtimeService
                    .deleteChannel(
                        channelId
                    );

                await handlerGetChannels();

            } catch (error) {

                handle(error);

            } finally {

                hideLoadingIndicator();
            }
        };

    const openCreateModal =
        () => {

            dispatch(
                clearSelectedChannel()
            );

            dispatch(
                setChannelModalOpen(true)
            );
        };

    const openEditModal =
        (
            channel: RealtimeChannelDTO
        ) => {

            dispatch(
                setSelectedChannel(channel)
            );

            dispatch(
                setChannelModalOpen(true)
            );
        };

    const closeModal =
        () => {

            dispatch(
                setChannelModalOpen(false)
            );

            dispatch(
                clearSelectedChannel()
            );
        };

    return {

        channels:
            realtime.channels,

        selectedChannel:
            realtime.selectedChannel,

        channelModalOpen:
            realtime.channelModalOpen,

        loading:
            realtime.loading,

        handlerGetChannels,

        handlerCreateChannel,

        handlerUpdateChannel,

        handlerDeleteChannel,

        openCreateModal,

        openEditModal,

        closeModal,
    };
};